import { Link } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { FileText, Users } from "lucide-react"

export default function HomePage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background p-4 sm:p-6">
      <div className="mb-6 text-center sm:mb-8">
        <h1 className="mb-2 text-balance text-3xl font-bold text-foreground sm:text-4xl lg:text-5xl">试卷管理平台</h1>
        <p className="text-pretty text-sm text-muted-foreground sm:text-base">选择您的角色以继续</p>
      </div>

      <div className="w-full max-w-4xl grid gap-4 sm:gap-6 grid-cols-1 sm:grid-cols-2 px-4">
        <Link to="/admin" className="w-full">
          <Card className="cursor-pointer transition-all hover:-translate-y-1 hover:shadow-lg h-full">
            <CardHeader className="text-center">
              <div className="mx-auto mb-3 flex h-14 w-14 sm:h-16 sm:w-16 items-center justify-center rounded-full bg-primary/10">
                <FileText className="h-7 w-7 sm:h-8 sm:w-8 text-primary" />
              </div>
              <CardTitle className="text-lg sm:text-xl">管理员</CardTitle>
              <CardDescription className="text-sm">管理试卷列表和数据统计</CardDescription>
            </CardHeader>
            <CardContent className="text-center pb-6">
              <Button className="w-full">进入管理</Button>
            </CardContent>
          </Card>
        </Link>

        <Link to="/browse" className="w-full">
          <Card className="cursor-pointer transition-all hover:-translate-y-1 hover:shadow-lg h-full">
            <CardHeader className="text-center">
              <div className="mx-auto mb-3 flex h-14 w-14 sm:h-16 sm:w-16 items-center justify-center rounded-full bg-primary/10">
                <Users className="h-7 w-7 sm:h-8 sm:w-8 text-primary" />
              </div>
              <CardTitle className="text-lg sm:text-xl">学生</CardTitle>
              <CardDescription className="text-sm">浏览和搜索试卷</CardDescription>
            </CardHeader>
            <CardContent className="text-center pb-6">
              <Button className="w-full">浏览试卷</Button>
            </CardContent>
          </Card>
        </Link>
      </div>
    </div>
  )
}
